import CommentThread, { CommentThreadProps } from './CommentThread';

type Props = Omit<CommentThreadProps, 'subject'> & { violationId: string };

/** A violation's Activity: `CommentThread` on a violation. */
export function ViolationCommentThread({ violationId, ...rest }: Props) {
  return (
    <CommentThread subject={{ kind: 'violation', id: violationId }} {...rest} />
  );
}

export default ViolationCommentThread;
